import { render } from "./AdminBanners.vue?vue&type=template&id=6189b2f0&scoped=true"
import script from "./AdminBanners.vue?vue&type=script&lang=js"
export * from "./AdminBanners.vue?vue&type=script&lang=js"

import "./AdminBanners.vue?vue&type=style&index=0&id=6189b2f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6189b2f0"]])

export default __exports__